import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { RecoBrandCardSkeleton } from '../RecoBrandCardSkeleton';
import { RecoCategoryCardSkeleton } from '../RecoCategoryCardSkeleton';
import { RecoProductCardSkeleton } from '../RecoProductCardSkeleton';

type RecoCarouseSkeletonProps = {
  /**
   * The type of skeleton cards to display. Default is `PRODUCT`.
   * @default "PRODUCT"
   */
  type?: 'CAT' | 'PRODUCT' | 'BRAND';
  /**
   * If `true`, the skeleton for title will not be displayed
   * @default false
   */
  hasNoTitle?: boolean;
};

/**
 * This component can be used to display a skeleton for the recommendations carousel.
 */
export const RecoCarouselSkeleton = ({
  hasNoTitle = false,
  type = 'PRODUCT',
}: RecoCarouseSkeletonProps) => {
  let skeletonToRender = <RecoProductCardSkeleton />;

  if (type === 'CAT') {
    skeletonToRender = <RecoCategoryCardSkeleton />;
  } else if (type === 'BRAND') {
    skeletonToRender = <RecoBrandCardSkeleton />;
  }
  return (
    <div>
      {!hasNoTitle && <Skeleton className="my-2 h-[2.25rem] w-[35%] rounded-sm" />}

      <div className="bg-color-grey-light p-2 pb-2 lg:p-3 lg:pb-5">{skeletonToRender}</div>
    </div>
  );
};
